import './style.scss';

import {
  faArrowDownLeftAndArrowUpRightToCenter,
  faArrowUpRightAndArrowDownLeftFromCenter,
  faClone,
  faXmarkLarge,
} from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box } from '@mui/material';
import React, { useContext } from 'react';

import TradingViewLogo from '../../assets/icons/trading-view-logo.svg';
import ResizeIcon from '../../assets/resize-icon.svg';
import { Size } from '../../model/size';
import { DashboardContext } from '../../providers/dashboard-provider';
import { GalleryContext } from '../../providers/gallery-provider';
import { OverviewContext } from '../../providers/overview-provider';

interface ParentCompProps {
  widget?: React.ReactNode;
  title?: string;
  sizes?: Size;
  cardId?: string;
  cardKey?: string;
  noHeader?: boolean;
  showFooter?: boolean;
  handleSettingsWidget?: (cardKey: string) => void;
  handleDeleteWidget?: (cardKey: string) => void;
  maximizeCard?: (card: string) => void;
  maximized?: string;
  classNames?: string;
  disabledSettings?: boolean;
  disabledRemove?: boolean;
  disabledMaximize?: boolean;
  showAttributionLogo?: boolean;
}

const DefaultWidget: React.FC<ParentCompProps> = (props) => {
  const {
    widget,
    title,
    cardId,
    cardKey,
    noHeader,
    showFooter,
    handleSettingsWidget,
    handleDeleteWidget,
    classNames,
    disabledSettings,
    disabledRemove,
    disabledMaximize,
    showAttributionLogo,
  } = props;
  const overviewContext = useContext(OverviewContext);
  const galleryContext = useContext(GalleryContext);

  const context = overviewContext.currency ? overviewContext : galleryContext;

  const maximizeCard = props.maximizeCard || context.maximizeCard;
  const maximized = props.maximized || context.maximized;

  const { source } = useContext(DashboardContext);

  const handleMaximize = (card: string) => {
    maximizeCard(card);
  };

  const canShowSettings = !disabledSettings;
  const canShowRemove = !disabledRemove;

  return (
    <Box className={`defaultWidget ${classNames ? classNames : ''}`}>
      {!noHeader && (
        <Box className="widgetHeader">
          <div className={`widgetTitle ${!maximized && 'drag-area'}`}>
            <Box>{title}</Box>
          </div>
          {!disabledMaximize && (
            <button className="button" onClick={() => handleMaximize(cardKey || '')}>
              <FontAwesomeIcon
                icon={
                  !maximized
                    ? faArrowUpRightAndArrowDownLeftFromCenter
                    : faArrowDownLeftAndArrowUpRightToCenter
                }
              />
            </button>
          )}

          {canShowSettings && (
            <Box
              className="button"
              onClick={() => {
                if (handleSettingsWidget) {
                  handleSettingsWidget(cardKey!);
                }
              }}
            >
              <FontAwesomeIcon icon={faClone} />
            </Box>
          )}
          {canShowRemove && (
            <Box
              className="button"
              onClick={() => {
                if (handleDeleteWidget) {
                  handleDeleteWidget(cardId!);
                }
              }}
            >
              <FontAwesomeIcon icon={faXmarkLarge} />
            </Box>
          )}
        </Box>
      )}
      <Box className="widgetChartArea">{widget}</Box>
      {showFooter && (
        <Box className="widget-footer">
          <span className="widget-footer-source">
            Source: {source.charAt(0).toUpperCase() + source.toLocaleLowerCase().slice(1)}
          </span>

          {showAttributionLogo && (
            <a
              className="footer-attribution-logo-container"
              href="https://tradingview.com/"
              target="_blank"
              rel="noreferrer"
            >
              <img src={TradingViewLogo} alt="trading view" />
            </a>
          )}
        </Box>
      )}
      {!noHeader && <img src={ResizeIcon} alt="" className="resizeIcon" />}
    </Box>
  );
};

export default DefaultWidget;
